/*!
 * Custom theme js code goes here.
 */
// start mega-menu coding
jQuery(document).ready(($) => {
  // console.log("Theme script loadedd");
  // Options for noise
  const options = {
    animate: true,
    patternWidth: 100,
    patternHeight: 100,
    grainOpacity: 0.05,
    grainDensity: 1,
    grainWidth: 1,
    grainHeight: 1,
  };

  // check if #noise-container is available, if so, perform grained(element,options)
  if ($('#noise-container').length) {
    console.log('#noise-container availble');
    grained('#noise-container', options);
  }

  // Initiate mobile carousel - below is needed for framework, so eslint can ignore
  /* eslint-disable no-unused-vars */
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  /**
 *  3D SLIDER
 */
  const swiper3d = new Swiper('.swiper-d-container', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesOffsetBefore: -200,
    breakpoints: {
    // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    slidesPerView: 'auto',
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: '.swiper-pagination',
    },
  });
  // End carousel
  $('.modal').modal();
  $('.dropdown-trigger').dropdown();
  $('.tooltipped').tooltip();
  $('.materialboxed').materialbox();
  $('select').formSelect();
  $('.fixed-action-btn').floatingActionButton({
    direction: 'left',
    hoverEnabled: false,
    toolbarEnabled: false,
  });
  // Pushpin sidebar setup
  $(window).resize(() => {
    if ($(window).width() <= 480) {
      $('#sidebar-right').removeClass('pushpin-side pin-top');
      $('#recent-content').addClass('mobile-carousel');
      // console.log("mobile screen");
    }
    else if ($(window).width() > 480) {
      $('#recent-content').removeClass('mobile-carousel');
      // console.log("larger then mobile screen");
    }
  });
  // create searchform backdrop
  const searchBackDropWrapper = document.createElement('div');
  searchBackDropWrapper.setAttribute('id', 'searchBackDropWrapper');
  $('.page-layout').append(searchBackDropWrapper);

  // init searchform
  $('.search-form-icon, #searchBackDropWrapper').on('click', function () {
    const target = $('.js-form-type-search');
    const pageBody = $('body');
    const searchBtn = $('.search-form-btn-wrapper');
    const backdrop = $('#searchBackDropWrapper');
    if ($(pageBody).hasClass('path-search-site') === false) {
    // console.log("where good");
      if ($(target).hasClass('active')) {
        $('.custom-search-form').focusout();
        $(searchBtn).animate({
          width: `${0}%`,
          opacity: 0,
        }, 300);
        $(target).animate({
          opacity: 0,
          width: `${0}%`,
        }, 300);
        $(backdrop).animate({
          opacity: 0,
          width: `${0}%`,
        }, 300);
        $('.search-form-btn-wrapper').hide(400);
        $('.custom-search-form').val('');
        $(target).removeClass('active');
        $('.search-form-icon').removeClass('warning');
        $('.search-form-icon').text('search');
      }
      else {
        // $(this).hide(300);
        $('.search-form-btn-wrapper').show(10);
        $(target).animate({
          opacity: 1,
          width: `${100}%`,
        }, 600);
        $(searchBtn).animate({
          opacity: 1,
          width: `${100}%`,
        }, 600);
        $(backdrop).animate({
          opacity: 0.3,
          width: `${100}%`,
        }, 600);
        $(target).addClass('active');
        $('.custom-search-form').focus();
        $(this).addClass('warning');
        $('.search-form-icon').text('close');
      }
    }
  });

  // modal close button
  $('.path-search-site #search-filter .modal-close i').text('close');
  /*
$('.custom-search-form').on("focusout", function(){
  if($('body').hasClass('path-search-site') === false){
      $('.search-form-icon').show(400).addClass('pulse  warning');
  }
});
*/
  // Searchform behaviour on small mobile devices
  $('.page-wrapper-mobile').on('click', () => {
    const target = $('.js-form-type-search');
    const searchBtn = $('.search-form-btn-wrapper');
    if ($('body').hasClass('path-search-site') === false && $(target).hasClass('active') && $(window).width() < 481) {
    // console.log("Clicked  in body whilde form open");
      $(searchBtn).animate({
        width: `${0}%`,
        opacity: 0,
      }, 300);

      $(target).animate({
        opacity: 0,
        width: `${0}%`,
      }, 300);
      $('.custom-search-form').val('');
      $(target).removeClass('active');
      $('.search-form-icon').removeClass('warning');
      $('.search-form-icon').show();
    }
  });
  // Submitting the form
  $('.submit-form-icon').on('click', () => {
    const errorString = 'Het formulier kan niet leeg verzonden worden.';
    const warningString = 'Een zoekterm moet minimaal 3 karakters lang zijn. Pas je zoekopdracht aan.';
    // Throw a warning if the user input is less then 3 characters
    if ($('body').hasClass('path-search-site') === false) {
      if ($('#edit-search').val().length > 2) {
        $('#header-search-form').submit();
      }
    }
    else if ($('#edit-search--3').val().length > 2) {
      $('#header-search-form--2').submit();
    }
    if ($('body').hasClass('path-search-site') === false) {
      // Throw a warning if the user input is less then 3 characters
      if ($('.custom-search-form').val().length < 3 && $('.custom-search-form').val().length >= 1) {
        M.toast({
          html: Drupal.t(warningString),
          classes: 'toastWarning',
          displayLength: 5000,
        });
      }
      // Throw an error when the form is empty on submit.
      if ($('.custom-search-form').val().length === 0) {
        M.toast({
          html: Drupal.t(errorString),
          classes: 'toastError',
          displayLength: 5000,
        });
      }
    }
    else {
      // Throw a warning if the user input is less then 3 characters
      if ($('#edit-search--3').val().length < 3 && $('#edit-search--3').val().length >= 1) {
        M.toast({
          html: Drupal.t(warningString),
          classes: 'toastWarning',
          displayLength: 5000,
        });
      }
      // Throw an error when the form is empty on submit.
      if ($('#edit-search--3').val().length === 0) {
        M.toast({
          html: Drupal.t(errorString),
          classes: 'toastError',
          displayLength: 5000,
        });
      }
    }
  });
  // Check input state before submitting form  while pressing the enter button
  $('#edit-search--3').on('focusin', function () {
    const errorString = 'Het formulier kan niet leeg verzonden worden.';
    const warningString = 'Een zoekterm moet minimaal 3 karakters lang zijn. Pas je zoekopdracht aan.';
    $(this).off('keydown').keydown((event) => {
      if (event.keyCode === 13) {
        // console.log('enter!');
        event.preventDefault();
        // Throw a warning if the user input is less then 3 characters
        if ($('#edit-search--3').val().length < 3 && $('#edit-search--3').val().length >= 1) {
          M.toast({
            html: Drupal.t(warningString),
            classes: 'toastWarning',
            displayLength: 5000,
          });
        }
        // Throw an error when the form is empty on submit.
        if ($('#edit-search--3').val().length === 0) {
          M.toast({
            html: Drupal.t(errorString),
            classes: 'toastError',
            displayLength: 5000,
          });
        }
        if ($('#edit-search--3').val().length > 2) {
          $('#header-search-form--2').submit();
        }
      }
    });
  });

  // Check input state before submitting form  while pressing the enter button
  $('#edit-search').on('focusin', function () {
    const errorString = 'Het formulier kan niet leeg verzonden worden.';
    const warningString = 'Een zoekterm moet minimaal 3 karakters lang zijn. Pas je zoekopdracht aan.';
    $(this).off('keydown').keydown((event) => {
      if (event.keyCode === 13) {
        // console.log('enter!');
        event.preventDefault();
        // Throw a warning if the user input is less then 3 characters
        if ($('#edit-search').val().length < 3 && $('#edit-search').val().length >= 1) {
          M.toast({
            html: Drupal.t(warningString),
            classes: 'toastWarning',
            displayLength: 5000,
          });
        }
        // Throw an error when the form is empty on submit.
        if ($('#edit-search').val().length === 0) {
          M.toast({
            html: Drupal.t(errorString),
            classes: 'toastError',
            displayLength: 5000,
          });
        }
        if ($('#edit-search').val().length > 2) {
          $('#header-search-form').submit();
        }
      }
    });
  });

  // End searchform
  $(document).on('click', '.inline-block-list__item', () => {
    $('select').formSelect({
      isMultiple: false,
    });
    $('.tooltipped').tooltip();
  });
  $('.campaign-item.card .campaign-btn').on('mouseenter', function () {
    $(this).find('.link-icon').addClass('hover');
    $(this).addClass('hover');
  });
  $('.campaign-item.card .campaign-btn').on('mouseleave', function () {
    $(this).find('.link-icon').removeClass('hover');
    $(this).removeClass('hover');
  });
  $('.link.news-btn').on('mouseenter', function () {
    $(this).find('.link-icon').addClass('hover');
    $(this).addClass('hover');
  });
  $('.link.news-btn').on('mouseleave', function () {
    $(this).find('.link-icon').removeClass('hover');
    $(this).removeClass('hover');
  });
  const imgAnimate = $('.layout--threecol-section .field-name-field-afbeelding-solo img');
  const activeMenu = document.querySelectorAll('.mega-evidensia.menu--level-0 .menu-item div[class^="megamenu-container"]');
  const mainMenuItems = $('.menu--level-0 .menu--parent .top-level-link');
  const navArrow = $('.arrow-icon');
  let postionMegamenu = 0; // define variable
  // Megamenu
  if ($('.nav-wrapper .menu-dropdown .layout .layout__region').length > 0) {
    // check if there are any .mega-containers, no check = js error on pages without .mega-container
    if ($('.nav-wrapper .mega-container').length > 0) {
      // console.log("has menu");
      const ul = $('.mega-container');
      const ulPosition = $(ul).position();
      postionMegamenu = ulPosition.left - $(ul).outerWidth() / 2; // Styling images on campaignpage landscape images must have more width then portrait.
      // position the megamenucontainer in the center of the mainmenu
      $(activeMenu).css({
        left: `${postionMegamenu}px`,
      });
    }
  }
  // Styling images on campaignpage landscape images must have more width then portrait.
  const imgStyle = $('#builder-block-download-file img');
  const imgStyleSolo = $('#builder-block-solo-image img');

  function imageStyleWidth(elm, width) {
    $(elm).each(function () {
      const imgWidth = $(this).outerWidth();
      const imgHeight = $(this).outerHeight();
      if (imgWidth > imgHeight) {
        $(this).width(`${width}%`);
      }
    });
  }
  imageStyleWidth(imgStyle, 90);

  // Activate Tooltiops and selectfields when a ajax call is finished.
  jQuery(document).once().ajaxComplete((event, xhr, settings) => {
    $('select').formSelect();
    jQuery('.tooltipped').tooltip();
  });

  // Disable clicking
  $(mainMenuItems).on('click', function (e) {
    if ($(this).hasClass('sub-menu-item')) {
      // console.log("Click has class")
      $(this).click();
    }
    else {
      e.preventDefault();

      const target = $(this).parent().children('div');
      const pos = $(this).position();
      const value = Math.round(
        (pos.left - postionMegamenu + $(this).width() / 2) - $(navArrow).width() / 2,
      );
      $(activeMenu).each(function () {
        if ($(this).hasClass('active-menu') && !$(this).is($(target))) {
          $(this).hide().removeClass('active-menu');
          $(this).parent().removeClass('active');
        }
        else {
          setTimeout(() => {
            $(target).show().addClass('active-menu');
            $(target).parent().addClass('active');
            $(navArrow).stop(true, true).animate({
              left: `${Math.round(value)}px`,
            }, 700);
          }, 300);
        }
      });
    }
  });

  $(activeMenu).on('mouseleave', () => {
    setTimeout(() => {
      $(activeMenu).removeClass('active-menu').hide();
      $(activeMenu).parent().removeClass('active');
    }, 200);
  });
});
window.addEventListener('DOMContentLoaded', (event) => {
/* START ANIMATING H1 TITLE ON HOMEPAGE */
// Wrap every letter in a span
  if (document.querySelector('.path-frontpage')) {
    const textWrapper = document.querySelector('.welcomeMessage .letters');
    textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");

    anime.timeline({ loop: false })
      .add({
        targets: '.welcomeMessage .line',
        scaleY: [0, 1],
        opacity: [0.5, 1],
        easing: 'easeOutExpo',
        duration: 700,
      }).add({
        targets: '.welcomeMessage .line',
        translateX: [0, document.querySelector('.welcomeMessage .letters').getBoundingClientRect().width + 10],
        easing: 'easeOutExpo',
        duration: 700,
        delay: 100,
      }).add({
        targets: '.welcomeMessage .letter',
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 600,
        offset: '-=775',
        delay: (el, i) => 34 * (i + 1),
      })
      .add({
        targets: '.welcomeMessage .letter .spanperiod',
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 600,
        offset: '-=775',
        delay: (el, i) => 34 * (i + 1),
      })
      .add({
        targets: '.welcomeMessage .line',
        opacity: 0,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 0,
      });
  }
  /* START ANIMATING H1 TITLE */

  /* START ANIMATING H1 PAGETITLE */
  if (document.querySelector('.page-node-type-campaign')) {
    const pageTitleWrapper = document.querySelector('.pageTitle .letters');
    pageTitleWrapper.innerHTML = pageTitleWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    anime.timeline({ loop: false })
      .add({
        targets: '.pageTitle .letter',
        scale: [0.3, 1],
        opacity: [0, 1],
        translateZ: 0,
        easing: 'easeOutExpo',
        duration: 600,
        delay: (el, i) => 70 * (i + 1),
      }).add({
        targets: '.pageTitle .line',
        scaleX: [0, 1],
        opacity: [0.5, 1],
        easing: 'easeOutExpo',
        duration: 700,
        offset: '-=875',
        delay: (el, i, l) => 80 * (l - i),
      }).add({
        targets: '.pageTitle',
        opacity: 1,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 1000,
      });
  }
/* END ANIMATING H1 PAGETITLE */
});
